'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const weekdaySelector = '.react-calendar__month-view__weekdays__weekday';
const daySelector = '.react-calendar__month-view__days__day';
const neighboorMonthDaySelector = '.react-calendar__month-view__days__day--neighboringMonth';
const selectedDaySelector = '.react-calendar__tile--active';
const GlobalStyle = styled.createGlobalStyle `
  ${weekdaySelector} {
    abbr {
      text-decoration: none;
    }
    color: ${({ theme }) => theme.designTokens.calendarMonthWeekdayColor};
    font-family: ${({ theme }) => theme.designTokens.calendarMonthWeekdayFontFamily};
    font-size: ${({ theme }) => theme.designTokens.calendarMonthWeekdayFontSize};
    font-weight: ${({ theme }) => theme.designTokens.calendarMonthWeekdayFontWeight};
    line-height: ${({ theme }) => theme.designTokens.calendarMonthWeekdayLineHeight};
    text-align: ${({ theme }) => theme.designTokens.calendarMonthWeekdayTextAlign};
  }

  ${daySelector} {
    abbr {
      text-decoration: none;
    }

    cursor: pointer;
    border: none;
    background-color: ${({ theme }) => theme.designTokens.calendarMonthDayBackgroundColor};
    font-size: ${({ theme }) => theme.designTokens.calendarMonthDayFontSize};
    color: ${({ theme }) => theme.designTokens.calendarMonthDayColor};
    text-align: ${({ theme }) => theme.designTokens.calendarMonthDayTextAlign};
    line-height: ${({ theme }) => theme.designTokens.calendarMonthDayLineHeight};
    font-family: ${({ theme }) => theme.designTokens.calendarMonthDayFontFamily};
    font-weight: ${({ theme }) => theme.designTokens.calendarMonthDayFontWeight};
    border-radius: ${({ theme }) => theme.designTokens.calendarMonthDayRadius};
    &:hover {
      background-color: ${({ theme }) => theme.designTokens.calendarMonthDayHoverBackgroundColor};
    }
    &:focus {
      border: none;
    }
  }

  ${daySelector}[disabled] {
    color: ${({ theme }) => theme.designTokens.calendarMonthDayDisabledColor};
    cursor: not-allowed;
    &:hover {
      color: ${({ theme }) => theme.designTokens.calendarMonthDayDisabledColor};
      background-color: ${({ theme }) => theme.designTokens.calendarMonthDayBackgroundColor};
    }
  }

  ${neighboorMonthDaySelector} {
    color: ${({ theme }) => theme.designTokens.calendarMonthDayDisabledColor};
  }

  /* stylelint-disable-next-line */
  ${daySelector}:focus,
  ${selectedDaySelector} {
    outline: none;
    background-color: ${({ theme }) => theme.designTokens.calendarMonthDayFocusBackgroundColor};
    color: ${({ theme }) => theme.designTokens.calendarMonthDayFocusTextColor};
    &:hover {
      background-color: ${({ theme }) => theme.designTokens.calendarMonthDayFocusBackgroundColor};
      color: ${({ theme }) => theme.designTokens.calendarMonthDayFocusTextColor};
    }
  }
`;
const IconContainer = styled__default.default.div `
  cursor: pointer;
  padding: 0 ${({ theme }) => theme.designTokens.calendarMonthNavIconPaddingX};
`;
const Styled = {
    IconContainer,
};

exports.GlobalStyle = GlobalStyle;
exports.Styled = Styled;
//# sourceMappingURL=Small.styles.js.map
